/**
 * Competition Event name presets (ADR-028 ManagedEventSummary.name).
 * UI catalogs only — still create via createManagedEventSummary / addManagedEvent.
 */

/** Sentinel for free-form custom event name in pickers. */
export const CUSTOM_EVENT_OPTION = "__custom__";

/**
 * Common badminton competition categories organizers expect.
 * @type {readonly string[]}
 */
export const COMPETITION_EVENT_PRESETS = Object.freeze([
  "Men's Singles Open",
  "Women's Singles Open",
  "Men's Doubles Open",
  "Women's Doubles Open",
  "Mixed Doubles Open",
  "Men's Singles",
  "Women's Singles",
  "Men's Doubles",
  "Women's Doubles",
  "Mixed Doubles",
  "Men's Singles 35+",
  "Men's Singles 40+",
  "Men's Singles 45+",
  "Men's Singles 50+",
  "Men's Singles 55+",
  "Men's Singles 60+",
  "Women's Singles 35+",
  "Women's Singles 40+",
  "Women's Singles 45+",
  "Women's Singles 50+",
  "Men's Doubles 35+",
  "Men's Doubles 40+",
  "Men's Doubles 45+",
  "Men's Doubles 50+",
  "Women's Doubles 35+",
  "Women's Doubles 40+",
  "Women's Doubles 45+",
  "Mixed Doubles 35+",
  "Mixed Doubles 40+",
  "Boys' Singles U19",
  "Girls' Singles U19",
  "Boys' Doubles U19",
  "Girls' Doubles U19",
  "Mixed Doubles U19",
  "Boys' Singles U17",
  "Girls' Singles U17",
  "Boys' Doubles U17",
  "Girls' Doubles U17",
  "Boys' Singles U15",
  "Girls' Singles U15",
  "Boys' Doubles U15",
  "Girls' Doubles U15",
]);

/**
 * Resolve the display name to store on ManagedEventSummary.
 * @param {string} presetValue Dropdown value (preset label, "", or CUSTOM_EVENT_OPTION)
 * @param {string} [customName] Free-form name when custom is selected
 * @returns {string} Trimmed name, or "" if incomplete
 */
export function resolveCompetitionEventName(presetValue, customName = "") {
  const selected = String(presetValue || "").trim();
  if (!selected) return "";
  if (selected === CUSTOM_EVENT_OPTION) {
    return String(customName || "").trim();
  }
  return selected;
}
